
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-scorecard-verify',
  imports: [],
  templateUrl: './scorecard-verify.component.html',
  styleUrl: './scorecard-verify.component.scss',
})
export class ScorecardVerifyComponent implements OnInit {
  @Input() show = 'verified | unverified | none';

  constructor() {}

  ngOnInit() {}
}
